import { render, staticRenderFns } from "./EnrollPractice.vue?vue&type=template&id=23f857aa"
import script from "./EnrollPractice.vue?vue&type=script&lang=js"
export * from "./EnrollPractice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports